export default "<p>modal-invite works!</p>\r\n";